import React from 'react';
import PropTypes from 'prop-types';
import { Check } from '@phosphor-icons/react';
import './style';

const Checkbox = (props) => {
  const {
    label,
    subText,
    onChange,
    checked,
    disabled,
    className,
    id,
    ...attr
  } = props;

  const onClick = (e) => {
    if (!disabled) onChange(id, e);
  };

  return (
    <div
      className={`checkbox-wrapper flex gap-2${checked ? ' checked' : ''}${disabled ? ' disabled' : ''} ${className}`}
      onClick={onClick}
      {...attr}
    >
      <div className="checkbox-select relative">
        {checked && (
          <div className="checkmark absolute">
            <Check size={16}
              color="#FDFDFD" />
          </div>
        )}
      </div>
      <input type="checkbox" />
      {(label || subText) && (
        <div className="label-wrapper flex flex-col justify-center gap-1">
          {label && (<span className="label label-14">{label}</span>)}
          {subText && (<span className="sub-text text-14">{subText}</span>)}
        </div>)}
    </div>
  );

};

Checkbox.propTypes = {
  label: PropTypes.node,
  subText: PropTypes.node,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
};

Checkbox.defaultProps = {
  label: '',
  subText: '',
  onChange: () => null,
  checked: false,
  disabled: false,
  className: '',
  id: '',
};

export default Checkbox;
